import { devWarn } from '../../utils/devLog';

export function createAudioContextSafely(): AudioContext | null {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const AudioContextClass = window.AudioContext ||
      (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;

    if (!AudioContextClass) {
      return null;
    }

    return new AudioContextClass();
  } catch (error) {
    devWarn('AudioSystem: Failed to create AudioContext:', error);
    return null;
  }
}
